import revive_payload_client_n2yqP8hspj from "/app/node_modules/.pnpm/nuxt@3.13.1_@types+node@18.19.110_eslint@9.28.0_less@4.3.0_typescript@5.8.3_vite@6.3.5/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_ZnHhqMxkfu from "/app/node_modules/.pnpm/nuxt@3.13.1_@types+node@18.19.110_eslint@9.28.0_less@4.3.0_typescript@5.8.3_vite@6.3.5/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_ICobodaI3P from "/app/node_modules/.pnpm/nuxt@3.13.1_@types+node@18.19.110_eslint@9.28.0_less@4.3.0_typescript@5.8.3_vite@6.3.5/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_rxh87meLsN from "/app/node_modules/.pnpm/nuxt@3.13.1_@types+node@18.19.110_eslint@9.28.0_less@4.3.0_typescript@5.8.3_vite@6.3.5/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_87YxcPps5F from "/app/node_modules/.pnpm/nuxt@3.13.1_@types+node@18.19.110_eslint@9.28.0_less@4.3.0_typescript@5.8.3_vite@6.3.5/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_qtCWFAE2P3 from "/app/node_modules/.pnpm/nuxt@3.13.1_@types+node@18.19.110_eslint@9.28.0_less@4.3.0_typescript@5.8.3_vite@6.3.5/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_uke02o0UsB from "/app/node_modules/.pnpm/nuxt@3.13.1_@types+node@18.19.110_eslint@9.28.0_less@4.3.0_typescript@5.8.3_vite@6.3.5/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_hoGGmLr072 from "/app/node_modules/.pnpm/@pinia+nuxt@0.4.11_typescript@5.8.3_vue@3.5.16/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_xq70Qph92N from "/app/node_modules/.pnpm/nuxt@3.13.1_@types+node@18.19.110_eslint@9.28.0_less@4.3.0_typescript@5.8.3_vite@6.3.5/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import bmui_6qgoJ5AxSg from "/app/plugins/bmui.ts";
import countdown_olk6LFpgGt from "/app/plugins/countdown.ts";
import directives_8CcCirWtnE from "/app/plugins/directives.ts";
import ga_client_7dQ7yMojeg from "/app/plugins/ga.client.ts";
import im_client_8ex9Cq7J7y from "/app/plugins/im.client.ts";
import inject_worker_futures_client_mvBigGgzOV from "/app/plugins/inject-worker-futures.client.ts";
import inject_worker_client_9HnSu1iw9h from "/app/plugins/inject-worker.client.ts";
import request_host_PNNsgYv6Ze from "/app/plugins/request-host.ts";
import setup_client_LCITs7LDia from "/app/plugins/setup.client.ts";
import vue_platform_all_3ZnWe25KPs from "/app/plugins/vue-platform-all.ts";
import websocket_worker_client_woUwPoBAnW from "/app/plugins/websocket-worker.client.ts";
export default [
  revive_payload_client_n2yqP8hspj,
  unhead_ZnHhqMxkfu,
  router_ICobodaI3P,
  payload_client_rxh87meLsN,
  navigation_repaint_client_87YxcPps5F,
  check_outdated_build_client_qtCWFAE2P3,
  chunk_reload_client_uke02o0UsB,
  plugin_vue3_hoGGmLr072,
  components_plugin_KR1HBZs4kY,
  prefetch_client_xq70Qph92N,
  bmui_6qgoJ5AxSg,
  countdown_olk6LFpgGt,
  directives_8CcCirWtnE,
  ga_client_7dQ7yMojeg,
  im_client_8ex9Cq7J7y,
  inject_worker_futures_client_mvBigGgzOV,
  inject_worker_client_9HnSu1iw9h,
  request_host_PNNsgYv6Ze,
  setup_client_LCITs7LDia,
  vue_platform_all_3ZnWe25KPs,
  websocket_worker_client_woUwPoBAnW
]